import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-company-summary',
  templateUrl: './company-summary.component.html',
  styleUrl: './company-summary.component.scss'
})
export class CompanySummaryComponent {
  @Input() profile = null;
}
